import React from 'react';

function JumbotronButton({text="Go to Dashboard"}){
    return (
        <button className="action-button"><span>{text}</span></button>
    );
}

export default JumbotronButton;